const DEFAULT_THEME = 'light';
const lightTheme = {
  colorScheme: 'light',
  background: 'inherit',
  colorTextDefault: '#16191f',
  colorTextHeading: '#16191f',
  colorTextLink: '#0073bb',
  colorTextLinkHover: '#0a4a74',
  colorTextSelected: '#b3d8ff',
  colorInlineCodeText: '#d13212',
  colorCopyCodeIcon: '#545b64',
  colorCopyCodeIconHover: '#16191f',
  colorCopyCodeBorder: '#eaeded',
  colorKeyboardBorder: 'rgba(63, 63, 63, 0.25)',
  codeBlockBorderRadius: '4px',
  codeBlockBorder: '1px solid #ddd',
  codeBlockBackground: '#d5dbdb',
  table: {
    tbodyBgColor: '#FFFFFF',
    thBgColor: '#fafafa',
    thFontColor: '#696969',
    thBorderColor: '#DCDCDC'
  },
  blockquote: {
    bqBgColor: '#fafafa',
    bqBorderColor: '#DCDCDC'
  },
  expandableSection: {
    containerBgColor: '#fafafa',
    containerBoxShadow: 'rgba(0, 28, 36, 0.3) 0px 1px 1px 0px, rgba(0, 28, 36, 0.15) 1px 1px 1px 0px, rgba(0, 28, 36, 0.15) -1px 1px 1px 0px',
    containerBorderTop: '1px solid #eaeded',
    contentBgColor: '#ffffff',
    triggerTextColor: '#545b64',
    triggerTextHoverColor: '#16191f',
    triggerBorderColor: '#eaeded',
    borderRadius: '0px',
    marginBottom: '0px'
  },
  alert: {
    infoBorderColor: '#0073bb',
    infoBgColor: '#f1faff',
    infoIconColor: '#0073bb',
    successBorderColor: '#1d8102',
    successBgColor: '#f2f8f0',
    successIconColor: '#1d8102',
    errorBorderColor: '#d13212',
    errorBgColor: '#fdf3f1',
    errorIconColor: '#d13212',
    warningBorderColor: '#906806',
    warningBgColor: '#fffce9',
    warningIconColor: '#906806'
  },
  icon: {
    linkColor: '#0073bb',
    errorColor: '#d13212',
    warningColor: '#d13212',
    successColor: '#1d8102',
    subtleColor: '#687078',
    invertedColor: '#ffffff',
    disabledColor: '#aab7b8'
  }
};
const lightVisualRefreshTheme = {
  colorScheme: 'light',
  background: 'inherit',
  colorTextDefault: '#000716',
  colorTextHeading: '#000716',
  colorTextLink: '#0972d3',
  colorTextLinkHover: '#033160',
  colorTextSelected: '#b3d8ff',
  colorInlineCodeText: '#d13212',
  colorCopyCodeIcon: '#545b64',
  colorCopyCodeIconHover: '#16191f',
  colorCopyCodeBorder: '#eaeded',
  colorKeyboardBorder: 'rgba(63, 63, 63, 0.25)',
  codeBlockBorderRadius: '8px',
  codeBlockBorder: '2px solid #d1d5db',
  codeBlockBackground: '#F4F4F4',
  table: {
    tbodyBgColor: '#FFFFFF',
    thBgColor: '#FFFFFF',
    thFontColor: '#414d5c',
    thBorderColor: '#e9ebed'
  },
  blockquote: {
    bqBgColor: '#fafafa',
    bqBorderColor: '#e9ebed'
  },
  expandableSection: {
    containerBgColor: '#ffffff',
    containerBoxShadow: 'none',
    containerBorderTop: '1px solid #B6BEC9',
    contentBgColor: '#ffffff',
    triggerTextColor: '#545b64',
    triggerTextHoverColor: '#16191f',
    triggerBorderColor: '#eaeded',
    borderRadius: '16px',
    marginBottom: '8px'
  },
  alert: {
    infoBorderColor: '#0972d3',
    infoBgColor: '#f2f8fd',
    infoIconColor: '#0972d3',
    successBorderColor: '#037f0c',
    successBgColor: '#f2fcf3',
    successIconColor: '#037f0c',
    errorBorderColor: '#d91515',
    errorBgColor: '#fff7f7',
    errorIconColor: '#d91515',
    warningBorderColor: '#8d6605',
    warningBgColor: '#fffce9',
    warningIconColor: '#8d6605'
  },
  icon: {
    linkColor: '#0972d3',
    errorColor: '#d91515',
    warningColor: '#8d6605',
    successColor: '#037f0c',
    subtleColor: '#5f6b7a',
    invertedColor: '#ffffff',
    disabledColor: '#9ba7b6'
  }
};
const darkTheme = {
  colorScheme: 'dark',
  background: 'inherit',
  colorTextDefault: '#D5DBDB',
  colorTextHeading: '#eaeded',
  colorTextLink: '#44b9d6',
  colorTextLinkHover: '#99cbe4',
  colorTextSelected: 'rgba(51, 136, 221, 0.5)',
  colorInlineCodeText: '#D88B4A',
  colorCopyCodeIcon: '#d5dbdb',
  colorCopyCodeIconHover: '#fafafa',
  colorCopyCodeBorder: '#879596',
  colorKeyboardBorder: 'rgba(135, 149, 150, 1)',
  codeBlockBorderRadius: '4px',
  codeBlockBorder: '1px solid #515151',
  codeBlockBackground: '#515151',
  table: {
    tbodyBgColor: '#2a2e33',
    thBgColor: '#21252c',
    thFontColor: '#95a5a6',
    thBorderColor: '#484848'
  },
  blockquote: {
    bqBgColor: '#21252c',
    bqBorderColor: '#484848'
  },
  expandableSection: {
    containerBgColor: '#21252c',
    containerBoxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 1px 0px, rgba(0, 0, 0, 0.3) 1px 1px 1px 0px, rgba(0, 0, 0, 0.3) -1px 1px 1px 0px',
    containerBorderTop: '1px solid #2a2e33',
    contentBgColor: '#2B2E34',
    triggerTextColor: '#d5dbdb',
    triggerTextHoverColor: '#fafafa',
    triggerBorderColor: '#414750',
    borderRadius: '0px',
    marginBottom: '0px'
  },
  alert: {
    infoBorderColor: '#00a1c9',
    infoBgColor: '#12293b',
    infoIconColor: '#44b9d6',
    successBorderColor: '#1d8102',
    successBgColor: '#172211',
    successIconColor: '#6aaf35',
    errorBorderColor: '#d13212',
    errorBgColor: '#270a11',
    errorIconColor: '#ff5d64',
    warningBorderColor: '#e0ca57',
    warningBgColor: '#1d1906',
    warningIconColor: '#e0ca57'
  },
  icon: {
    linkColor: '#44b9d6',
    errorColor: '#ff5d64',
    warningColor: '#ff5d64',
    successColor: '#6aaf35',
    subtleColor: '#aab7b8',
    invertedColor: '#16191f',
    disabledColor: '#687078'
  }
};
const darkVisualRefreshTheme = {
  colorScheme: 'dark',
  background: 'inherit',
  colorTextDefault: '#d1d5db',
  colorTextHeading: '#e9ebed',
  colorTextLink: '#539fe5',
  colorTextLinkHover: '#89bdee',
  colorTextSelected: 'rgba(51, 136, 221, 0.5)',
  colorInlineCodeText: '#D88B4A',
  colorCopyCodeIcon: '#d5dbdb',
  colorCopyCodeIconHover: '#fafafa',
  colorCopyCodeBorder: '#879596',
  colorKeyboardBorder: 'rgba(135, 149, 150, 1)',
  codeBlockBorderRadius: '8px',
  codeBlockBorder: '2px solid #5f6b7a',
  codeBlockBackground: '#192534',
  table: {
    tbodyBgColor: '#0f1b2a',
    thBgColor: '#0f1b2a',
    thFontColor: '#9ba7b6',
    thBorderColor: '#414d5c'
  },
  blockquote: {
    bqBgColor: '#0f1b2a',
    bqBorderColor: '#414d5c'
  },
  expandableSection: {
    containerBgColor: '#0f1b2a',
    containerBoxShadow: 'none',
    containerBorderTop: '1px solid #414D5C',
    contentBgColor: '#0f1b2a',
    triggerTextColor: '#d5dbdb',
    triggerTextHoverColor: '#fafafa',
    triggerBorderColor: '#414750',
    borderRadius: '16px',
    marginBottom: '8px'
  },
  alert: {
    infoBorderColor: '#539fe5',
    infoBgColor: '#00142b',
    infoIconColor: '#539fe5',
    successBorderColor: '#29ad32',
    successBgColor: '#001a02',
    successIconColor: '#29ad32',
    errorBorderColor: '#eb6f6f',
    errorBgColor: '#1a0000',
    errorIconColor: '#eb6f6f',
    warningBorderColor: '#e0ca57',
    warningBgColor: '#1d1906',
    warningIconColor: '#e0ca57'
  },
  icon: {
    linkColor: '#539fe5',
    errorColor: '#eb6f6f',
    warningColor: '#e0ca57',
    successColor: '#29ad32',
    subtleColor: '#9ba7b6',
    invertedColor: '#000716',
    disabledColor: '#5f6b7a'
  }
};

export { DEFAULT_THEME, darkTheme, darkVisualRefreshTheme, lightTheme, lightVisualRefreshTheme };
